import type { CropVarietyConfigurationsByKey } from "../types.js";

export const hazelnutVarietyConfigurations = {
    "hazelnut.barcelona": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.butler": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.clark": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.daviana": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.dorris": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.ennis": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.epsilon": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.eta": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.felix": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.gamma": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.jefferson": { crop: "hazelnut", aliases: [], isExample: true, customName: false },
    "hazelnut.lewis": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.mcdonald": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.palaz": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.polly-o": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.sacajawea": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.santiam": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.theta": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.tombul": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.tonda-di-giffoni": { crop: "hazelnut", aliases: ["Giffoni"], isExample: false, customName: false },
    "hazelnut.tonda-gentile": {
        crop: "hazelnut",
        aliases: ["Tonda Gentile delle Langhe", "Tonda Gentile Trilobata"],
        isExample: false,
        customName: false,
    },
    "hazelnut.tonda-pacifica": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.wepster": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.willamette": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.yamhill": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.york": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.zeta": { crop: "hazelnut", aliases: [], isExample: false, customName: false },
    "hazelnut.custom": { crop: "hazelnut", aliases: [], isExample: false, customName: true },
} as const satisfies CropVarietyConfigurationsByKey;
